import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'
import {StyleParamType, wixColorParam, createStylesParams} from '@wix/tpa-settings'

import {colorMetadata, numberMetadata} from '../../../utils/builderMetadata'

export type ImageStylesParams = {
  imageCornerRadiusTopLeft: StyleParamType.Number
  imageCornerRadiusTopRight: StyleParamType.Number
  imageCornerRadiusBottomLeft: StyleParamType.Number
  imageCornerRadiusBottomRight: StyleParamType.Number
  imageOpacity: StyleParamType.Number
  imageBehindColor: StyleParamType.Color
}

export const imageStylesParams = createStylesParams<ImageStylesParams>({
  imageCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderTopLeftRadius, {defaultValue: 0}),
  },
  imageCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderTopRightRadius, {defaultValue: 0}),
  },
  imageCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderBottomLeftRadius, {defaultValue: 0}),
  },
  imageCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderBottomRightRadius, {defaultValue: 0}),
  },
  imageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
    metadata: numberMetadata(StyleType.number, {defaultValue: 100}, 'Image opacity from 0 to 100'),
  },
  imageBehindColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.06),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-5', 0.06),
  },
})
